var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['pass-dot', _vm.switchStr().className]},[_c('i',{staticClass:"dot"}),_c('i',[_vm._v(_vm._s(_vm.switchStr().label))])])}
var staticRenderFns = []

export { render, staticRenderFns }